/** Encodes a text and images url into a single string to represent a multimodal query */
export const encodeMultimodalQueryInternal = (
  text: string,
  imageUrls: string[]
): string => {
  return `||text||${text}||image||${imageUrls.join(",")}`;
};

/**
 * Decodes a multimodal query string into a text and images url.
 * Returns undefined if the query is not a multimodal query.
 */
export const decodeMultimodalQueryInternal = (
  query: string | undefined
): { text: string; imageUrls: string[] } | undefined => {
  if (query === undefined) {
    return undefined;
  }

  const pattern = /^\|\|text\|\|(.*)\|\|image\|\|(.*)$/;
  const match = query.match(pattern);
  if (match) {
    const [, text, imageUrls] = match;
    return {
      text: text ?? "",
      imageUrls: (imageUrls ?? "").split(",").filter(Boolean),
    };
  } else {
    return undefined;
  }
};
